import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { getUsers } from "../apinew";
import { Users } from "lucide-react";

export default function AdminDashboardOverview() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  const rawUser = localStorage.getItem("user");
  const currentUser = rawUser ? JSON.parse(rawUser) : null;

  const isAdmin = currentUser?.role === "admin";

  const loadData = async () => {
    try {
      setLoading(true);

      try {
        const userList = await getUsers();
        setUsers(Array.isArray(userList) ? userList : []);
      } catch (err) {
        console.error("Gagal load users:", err);
      }
    } catch (err) {
      console.error("Error:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isAdmin) {
      loadData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!isAdmin) {
    return (
      <div
        style={{
          padding: "24px",
          minHeight: "100vh",
          background: "#f8fafc",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          style={{
            background: "#ffffff",
            borderRadius: "12px",
            border: "1px solid #fee2e2",
            padding: "40px",
            textAlign: "center",
            maxWidth: "400px",
            boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
          }}
        >
          <div
            style={{
              fontSize: "48px",
              margin: "0 auto 16px",
            }}
          >
            🚫
          </div>
          <h3
            style={{
              fontSize: "20px",
              fontWeight: "600",
              color: "#0f172a",
              marginBottom: "8px",
            }}
          >
            Akses Ditolak
          </h3>
          <p style={{ fontSize: "14px", color: "#64748b", margin: 0 }}>
            Anda tidak memiliki akses ke halaman ini.
          </p>
        </motion.div>
      </div>
    );
  }

  return (
    <div style={{ padding: "24px", minHeight: "100vh", background: "#f8fafc" }}>
      {/* Header */}
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        style={{ marginBottom: "24px" }}
      >
        <h2
          style={{
            fontSize: "24px",
            fontWeight: "700",
            color: "#0f172a",
            marginBottom: "4px",
          }}
        >
          Dashboard Overview
        </h2>
        <p style={{ fontSize: "14px", color: "#64748b", margin: 0 }}>
          Ringkasan aktivitas dan statistik sistem
        </p>
      </motion.div>

      {loading ? (
        <div style={{ textAlign: "center", padding: "48px", color: "#94a3b8" }}>
          Memuat data...
        </div>
      ) : (
        <>
          {/* Stats Grid */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
              gap: "16px",
              marginBottom: "24px",
            }}
          >
            {/* Total User */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.05 }}
              whileHover={{
                scale: 1.02,
                boxShadow: "0 6px 12px rgba(0,0,0,0.08)",
                background: "#f9fafb",
              }}
              style={{
                background: "#ffffff",
                border: "1px solid #e2e8f0",
                borderRadius: "12px",
                padding: "20px",
                boxShadow:
                  "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
                transition: "all 0.2s ease",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  marginBottom: "12px",
                }}
              >
                <div>
                  <p style={{ fontSize: "12px", color: "#64748b", margin: 0 }}>
                    Total User
                  </p>
                  <h3
                    style={{
                      fontSize: "28px",
                      fontWeight: "700",
                      color: "#0f172a",
                      margin: "4px 0 0 0",
                    }}
                  >
                    {users.length}
                  </h3>
                </div>
                <div
                  style={{
                    background: "#dbeafe",
                    borderRadius: "8px",
                    padding: "10px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Users size={20} color="#1e40af" />
                </div>
              </div>
              <p style={{ fontSize: "12px", color: "#64748b", margin: 0 }}>
                Seluruh akun terdaftar
              </p>
            </motion.div>
          </div>
        </>
      )}
    </div>
  );
}
